import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { cn } from '@/utils/commons';
import { motion } from 'framer-motion';
import { fadeIn } from '@/utils/animations';

interface SimpleLoaderProps {
  isLoading?: boolean;
  title?: string;
  description?: string;
  mode?: 'fullscreen' | 'modal';
}

const SimpleLoader: React.FC<SimpleLoaderProps> = ({ isLoading = true, title, description, mode = 'fullscreen' }) => {
  const { t } = useTranslation();
  if (!isLoading) return null;

  const overlayClass = mode === 'modal' ? ' backdrop-blur-xs' : '';

  return (
    <motion.div
      className={cn(
        'fixed inset-0 z-[100] flex items-center justify-center bg-white dark:bg-[#18191b]/40',
        overlayClass
      )}
      initial={fadeIn.initial}
      animate={fadeIn.animate}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card
        className={cn(
          'w-full max-w-md mx-4 p-6 rounded-lg shadow-lg',
          mode === 'modal' ? 'border border-solid border-border' : ''
        )}
      >
        <CardHeader className="space-y-4 items-center">
          <div className="relative w-16 h-16">
            <div className="absolute inset-0 rounded-full border-4 border-muted animate-pulse"></div>
            <div className="absolute inset-2 rounded-full border-4 border-t-primary animate-spin"></div>
          </div>
          <CardTitle className="text-2xl font-bold text-center">{title ?? t('Global_Loading')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6 ">
          <p className="text-center text-muted-foreground pt-2">{description ?? t('global_please_wait')}</p>
          <div className="flex justify-center py-4">
            <div className="w-24 h-4 bg-muted rounded-full opacity-60" />
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default SimpleLoader;
